import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { LoadingStatus } from '../../../core/domain/events/state_provider';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { DietitianStateProvider } from '../../../data/dietitian/domain/dietitian_state_provider';
import { InvitationTemplate } from '../../../data/dietitian/domain/invitation_template/invitation-template';
import { InvitationTemplateCommands } from '../../../data/dietitian/domain/invitation_template/invitation-template-commands';
import { AccountViewModel } from '../../dashboard/routes/questions/routes/patients-list/patients-list.facade';

@Injectable()
export class InvitationEditorFacade {
  private basicContent =
    'Bonjour,\n\n' +
    'Je vous propose que nous restions en contact entre les consultations via l’application MonSuiviDiet.\n\n\n' +
    'Quels sont les avantages ?\n\n' +
    '✅ L’application propose un carnet alimentaire digitalisé qui vous permettra de noter vos observations jour après jour, de mieux prendre conscience de votre comportement alimentaire et de repérer plus facilement les situations problématiques. Je pourrai consulter vos repas depuis mon interface ce qui me permettra de vous donner des conseils plus personnalisés en consultation de suivi !\n\n' +
    '✅ Vous pourrez suivre directement sur l’application les objectifs fixés en consultation pour rester motivé·e et mieux évaluer vos difficultés comme vos réussites.\n\n' +
    '✅ Plus besoin d’attendre le prochain rendez-vous, vous pourrez me poser toutes vos questions entre deux consultations.\n\n' +
    'L’utilisation d’un outil digital permet de s’impliquer davantage dans son parcours de soin et d’ancrer les résultats sur le long terme !\n\n\n';

  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private commands: InvitationTemplateCommands,
  ) {
    // Nada
  }

  get accountStatus$(): Observable<AccountViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <AccountViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }

  getEmptyInvitationTemplate(): InvitationTemplate {
    return InvitationTemplate.create({ content: '' }, new UniqueEntityID(-1));
  }

  getDefaultInvitationTemplate(): InvitationTemplate {
    return InvitationTemplate.create(
      { content: this.basicContent },
      new UniqueEntityID(0),
    );
  }

  async getAllTemplate(dietitianId: string): Promise<InvitationTemplate[]> {
    return this.commands.getAllTemplate(dietitianId);
  }
}
